





















import { Vue, Prop, Component, Watch } from 'vue-property-decorator'

@Component
export default class extends Vue {
  @Prop({ default: 'plus-circle' }) public iconName!: string
  @Prop({ default: 'sample Button' }) public title!: string
  @Prop({ default: false }) public disable!: boolean
  @Prop({ default: () => null }) public callback!: () => void
}
